<template>
	<div class="onboarding">
		<slot></slot>
	</div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.onboarding {
	background-image: url(~@/assets/pre/onboarding-bg.svg);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: 50% 70%;
	background-color: #fff;
}
</style>
